import { EntityRequestHoliday } from "../../entity/EntityRequestHoliday";

export class DtoRequestHolidaysDeleteRes extends EntityRequestHoliday {
  public message: string | null = null;
}
